export const FREQUENCY = {
  NONE: 0,
  DAILY: 1,
  BI_WEEKLY: 3,
  WEEKLY: 7,
  BI_MONTHLY: 15,
  MONTHLY: 30,
}

export const NEWSLETTERS_NAMES = {
  bestDeals: 'bon_plan',
  sletter: 'sletter',
}

export const getFrequency = ({
  frequency,
  marketing_newsletter_choices: choices,
}) => {
  if (
    frequency === FREQUENCY.NONE &&
    choices.length > 1 &&
    choices.includes(FREQUENCY.WEEKLY)
  ) {
    return FREQUENCY.WEEKLY
  }

  return frequency
}
